import React, { Component } from 'react';
import './App.css';
import InsuranceApplication from './model/insurance-application';
import ApplicationValue from './model/application-value';
import Insurer from './model/insurer';
import { ApkForm } from './components/apk-form';
import { InsurerForm } from './components/insurer-form';
import { InsuredForm } from './components/insured-form';
import { CropsForm } from './components/crops-form';
import { CompletedForm } from './components/completed';
import PermissionsForm from './components/permissions-form';
import Insured from './model/insured';

import { Container, Grid, Button, Stepper, Step, StepLabel, Box, Divider, AppBar, Toolbar, Fab } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { withStyles, Theme } from '@material-ui/core/styles';

const styles = withStyles((theme: Theme) => ({
  text: {
    padding: theme.spacing(2, 2, 0),
  },
  paper: {
    paddingBottom: 50,
  },
  list: {
    marginBottom: theme.spacing(2),
  },
  subheader: {
    backgroundColor: theme.palette.background.paper,
  },
  box: {
    margin: "-24px",
    marginTop: "24px",
  },
  appBar: {
    top: 'auto',
    bottom: 0,
  },
  headerBar: {

  },
  grow: {
    flexGrow: 1,
  },
  div: {
    position: 'absolute',
    zIndex: 1,
    top: -50,
    left: 0,
    right: 0,
    margin: '0 auto',
    marginTop: '40px',
    width: '64px',
    height: '32px',
    borderBottomLeftRadius: '110px',
    borderBottomRightRadius: '110px',
    textAlign: 'center',
    backgroundColor: 'white'
  },
  fabButton: {
    position: 'absolute',
    zIndex: 1,
    top: -30,
    left: 0,
    right: 0,
    margin: '0 auto',
  },
  addButtonLabel: {
    justifySelf: "flex-end"
  },
  img: {
    marginTop: '8px'
  },
  title: {
    fontSize: '14pt',
    textAlign: 'center',
    color: '#008000',
    fontWeight: 'normal'
  },
  fabIcon: {
    color: 'white'
  },
  finishButton: {
    margin: '0 auto',
  }
}
));

class App extends Component<any, any> {

  constructor(props: any) {
    super(props);
    this.state = {
      step: 0,
      isValid: false,
      application: new InsuranceApplication()
    };

    this.renderButtons = this.renderButtons.bind(this);
  }

  onApkValidation = (errors: string[]) => {
  }

  onApkChanged = (data: ApplicationValue[]) => {
    let ia = this.state.application as InsuranceApplication;
    let av = ia.applicationValues.filter((element) => !element.key.startsWith('apk'));
    ia.applicationValues = [...av, ...data];

    this.setState({ application: ia });
  }

  onInsurerChanged = (data: Insurer) => {
    let ia = this.state.application as InsuranceApplication;
    ia.insurer = data;

    this.setState({ application: ia });
  }

  onInsuredChanged = (data: Insured) => {
    let ia = this.state.application as InsuranceApplication;
    ia.insured = data;

    this.setState({ application: ia });
  }

  onInsuranceCoverageChanged = (data: ApplicationValue[]) => {
    let ia = this.state.application as InsuranceApplication;
    let av = ia.applicationValues.filter((element) => element.key.startsWith('apk'));
    ia.applicationValues = [...av, ...data];

    this.setState({ application: ia });
  }

  onCropsChanged = (data: any) => {
    let ia = this.state.application as InsuranceApplication;
    ia.crops = data.crops;
    ia.applicationValues = data.applicationValues;

    this.setState({ application: ia });
  }

  onPermissionsChanged = (data: ApplicationValue[]) => {
    let ia = this.state.application as InsuranceApplication;
    let av = ia.applicationValues.filter((element) => !element.key.startsWith('oswiadczenie'));
    ia.applicationValues = [...av, ...data];

    this.setState({ application: ia });
  }

  handleBackClick = (event: any) => {
    let step = this.state.step - 1;
    this.setState({ step: step })
  }

  handleNextClick = async (event: any) => {
    let step = this.state.step + 1;
    this.setState({ step: step });
  }

  renderHeader() {
    const { classes } = this.props;

    return (
      <AppBar position="sticky" color="default" className={classes.headerBar}>
        <Toolbar>
          <Grid container>
            <Grid container alignItems="flex-end" item sm={5} xs={12}><Box m="auto"><img src="/images/saga-brokers.png" alt="SAGA Brokers" width="200px" className={classes.img} /></Box></Grid>
            <Grid container alignContent="center" item sm={7} xs={12}><p className={classes.title}>WNIOSEK OBOWIĄZKOWEGO UBEZPIECZENIA UPRAW ROLNYCH Z DOPŁATĄ Z BUDŻETU PAŃSTWA</p></Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    )
  }

  renderButtons(nextButton: any, prevButton: any, addClick: any, middleButton: any) {
    const { classes } = this.props;
    return (
      <Box className={classes.box}>

        <AppBar position="static" color="default" className={classes.appBar}>
          <Toolbar>
            {prevButton ?
              <Button variant="text" color="inherit" onClick={prevButton.click}>{prevButton.caption}</Button>
              : null}

            {addClick ?
              <>
                <div className={classes.div}>
                  <Fab color="secondary" type="button" aria-label="add" className={classes.fabButton} onClick={addClick}>
                    <AddIcon />
                  </Fab>
                </div>
              </>
              : null}

            {middleButton ?
              <Button variant="text" color="inherit" className={classes.finishButton} onClick={middleButton.click}>{middleButton.caption}</Button>
              : null}


            {nextButton ?
              <>
                <div className={classes.grow} />
                <Button variant="text" color="inherit" onClick={nextButton.click}>{nextButton.caption}</Button>
              </>
              : null}

          </Toolbar>
        </AppBar>
      </Box>
    )
  }

  render() {
    return (
      <>
        <Container component="main" maxWidth="md" className="container">
          {this.renderHeader()}
          <Box className="paper">
            <Grid container spacing={2}>
              {
                this.state.step < 6 ?
                  <Grid item md={12}>

                    <Stepper className="stepper" activeStep={this.state.step} alternativeLabel>
                      {["APK", "Ubezpieczający", "Ubezpieczony", "Uprawy i zakres ubezpieczenia", "Oświadczenia"].map((label, index) => {
                        const stepProps: { completed?: boolean } = {};
                        const labelProps: { optional?: React.ReactNode } = {};
                        return (
                          <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps}>{label}</StepLabel>
                          </Step>
                        );
                      })}
                    </Stepper>
                    <Divider />
                  </Grid>
                  : null
              }

              <Grid item md={12}>
                {
                  this.state.step === 0 ?
                    <ApkForm
                      nextClick={this.handleNextClick}
                      prevClick={this.handleBackClick}
                      renderButtons={this.renderButtons}
                      data={this.state.application.applicationValues.filter((elem: ApplicationValue) => elem.key.startsWith('apk'))}
                      onValidation={this.onApkValidation}
                      onDataChange={this.onApkChanged}
                      disabled={false} />
                    : null
                }
                {
                  this.state.step === 1 ?
                    <InsurerForm
                      nextClick={this.handleNextClick}
                      prevClick={this.handleBackClick}
                      renderButtons={this.renderButtons}
                      data={this.state.application.insurer as Insurer}
                      onDataChange={this.onInsurerChanged}
                      disabled={false} />
                    : null
                }
                {
                  this.state.step === 2 ?
                    <InsuredForm
                      nextClick={this.handleNextClick}
                      prevClick={this.handleBackClick}
                      renderButtons={this.renderButtons}
                      data={this.state.application.insured as Insured}
                      onDataChange={this.onInsuredChanged}
                      disabled={false} />
                    : null
                }
                {/* { 
              this.state.step === 3 ? 
                <InsuranceCoverageForm
                  nextClick={this.handleNextClick}
                  prevClick={this.handleBackClick}
                  renderButtons={this.renderButtons} 
                  data={this.state.application.applicationValues.filter((elem: ApplicationValue) => !elem.key.startsWith('apk') && !elem.key.startsWith('oswiadczenie'))} 
                  onDataChange={this.onInsuranceCoverageChanged}
                  disabled={false}/> 

              : null
            } */}
                {
                  this.state.step === 3 ?
                    <CropsForm
                      nextClick={this.handleNextClick}
                      prevClick={this.handleBackClick}
                      renderButtons={this.renderButtons}
                      data={this.state.application}
                      onDataChange={this.onCropsChanged}
                      disabled={false} />
                    : null
                }
                {
                  this.state.step === 4 ?
                    <PermissionsForm
                      nextClick={this.handleNextClick}
                      prevClick={this.handleBackClick}
                      renderButtons={this.renderButtons}
                      data={this.state.application.applicationValues.filter((elem: ApplicationValue) => elem.key.startsWith('oswiadczenie'))}
                      onDataChange={this.onPermissionsChanged}
                      disabled={false} />
                    : null
                }
                {
                  this.state.step === 5 ?
                    <CompletedForm
                      data={this.state.application}
                      prevClick={this.handleBackClick}
                      renderButtons={this.renderButtons}
                    />
                    : null
                }
              </Grid>
            </Grid>
          </Box>

        </Container>
      </>

      // <BrowserRouter>
      //   <Route exact path="/" render={(props) => <Analiza {...props} insuranceApplication={this.state.insuranceApplication} onDataChange={this.onApkChanged} disabled={false} />}/>     
      //   <Route exact path="/application" render={(props) => <Application {...props} insuranceApplication={this.state.insuranceApplication} disabled={false} />} />
      //   <Route exact path="/summary" render={(props) => <Summary {...props} insuranceApplication={this.state.insuranceApplication} disabled={true} />}/>
      //   <Route exact path="/complete" component={ Complete }/>
      // </BrowserRouter>
    )
  };
}

export default styles(App);
